import { loginError, loginSuccess, logoutSuccess } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import axios from "axios";
import { setAuthorization } from "helpers/api_helper";

interface User {
    email: string;
    password: string;
}

export const loginUser = (
    user: User,
    navigate: any
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        const response = await axios.post("/auth/login", {
            username: user.email,
            password: user.password,
        });

        const { token, expiresIn } = response.data;

        // Expiración como timestamp
        const expirationDate = new Date(Date.now() + expiresIn);
        sessionStorage.setItem("authToken", token);
        sessionStorage.setItem("authTokenExpires", expirationDate.toISOString());

        setAuthorization(token); // actualiza axios headers

        dispatch(loginSuccess({ token, user: { username: user.email } }));

        navigate("/dashboard");
    } catch (error: any) {
        const message = error.response?.data?.message || "Error al iniciar sesión";
        dispatch(loginError(message));
    }
};

export const logoutUser = (
    navigate?: any
  ): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("authTokenExpires");
      sessionStorage.removeItem("authUser");
  
      delete axios.defaults.headers.common["Authorization"];
  
      dispatch(logoutSuccess());
  
      if (navigate) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

export const socialLogin = () => async () => {
    console.warn("Social login no está implementado en este sistema.");
};